import React, { useState, useCallback } from 'react';

import { GTMTracking, Modal } from '@common/ui/general';

import facebookIcon from '@alumni_v2/images/svg/facebookIcon.svg';
import twitterIcon from '@alumni_v2/images/svg/twitterIcon.svg';

import styles from './ShareModal.module.scss';

const ShareModal = ({
  isOpen, onModalClose, shareLink, shareMessage,
}) => {
  const [copyText, setCopyText] = useState('Copy');

  const twitterShareSlug = `
    ${encodeURIComponent(shareMessage)}. ${encodeURIComponent(shareLink)}
  `;
  const facebookShareSlug = `${encodeURIComponent(shareLink)}`;
  const handleFacebookShare = useCallback(() => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${facebookShareSlug}`,
      '_blank',
    );
  }, [facebookShareSlug]);

  const handleTwitterShare = useCallback(() => {
    window.open(
      `https://twitter.com/intent/tweet?text=${twitterShareSlug}`,
      '_blank',
    );
  }, [twitterShareSlug]);


  const handleLinkCopy = useCallback(() => {
    setCopyText('Copied');
    navigator.clipboard.writeText(shareLink);
  }, [shareLink]);

  const handleModalClose = () => {
    setCopyText('Copy');
    onModalClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleModalClose}
      position="center"
      className={styles.containerUi}
      containerClassName={styles.bodyUi}
      headerClassName={styles.crossHeader}
      backdropClassName={styles.backdropClassName}
    >
      <div className={styles.headerContainer}>
        <div className={styles.title}>Share this profile via</div>
        <GTMTracking
          component="button"
          gtmEventType="cta"
          gtmEventAction="click"
          gtmEventResult="share_review_modal_close"
          gtmEventCategory="alumni_directory"
          gtmEventData={{
            click_type: 'share_review_modal_close',
          }}
          className={styles.closeIcon}
          onClick={handleModalClose}
        >
          &#x2DF;
        </GTMTracking>
      </div>
      <div className={styles.bodyContainer}>
        <div className={styles.shareIcons}>
          <GTMTracking
            component="button"
            gtmEventType="cta"
            gtmEventAction="click"
            gtmEventResult="share_review_on_facebook"
            gtmEventCategory="alumni_directory"
            gtmEventData={{
              click_type: 'share_review_on_facebook',
            }}
            className={styles.shareIcon}
            onClick={handleFacebookShare}
          >
            <img src={facebookIcon} alt="FaceBook_Icon" />
          </GTMTracking>
          <GTMTracking
            component="button"
            gtmEventType="cta"
            gtmEventAction="click"
            gtmEventResult="share_review_on_twitter"
            gtmEventCategory="alumni_directory"
            gtmEventData={{
              click_type: 'share_review_on_twitter',
            }}
            className={styles.shareIcon}
            onClick={handleTwitterShare}
          >
            <img src={twitterIcon} alt="Twitter_Icon" />
          </GTMTracking>
        </div>
        <div className={styles.linkBox}>
          <textarea
            className={styles.linkText}
            value={shareLink}
            readOnly
            autoFocus
          />
          <GTMTracking
            component="button"
            gtmEventType="cta"
            gtmEventAction="click"
            gtmEventResult="share_review_link_copy"
            gtmEventCategory="alumni_directory"
            gtmEventData={{
              click_type: 'share_review_link_copy',
            }}
            className={styles.copyBtn}
            onClick={handleLinkCopy}
          >
            {copyText}

          </GTMTracking>
        </div>
      </div>
    </Modal>
  );
};

export default ShareModal;
